export const APP_CONTEXT_KEYS = {
  USER_ROLE: 'USER-ROLE',
  USER_STATUS: 'USER-STATUS',
  GENDER: 'GENDER',
  SPECIALIZATION: 'SPECIALIZATION',
  MED_DEGREE: 'MED-DEGREE',
  APPOINTMENT_TYPE: 'APPOINTMENT-TYPE',
  APPOINTMENT_STATUS: 'APPOINTMENT-STATUS',
  BILLING_SERVICE_TYPE: 'BILLING-SERVICE-TYPE',
  PAYMENT_METHOD: 'PAYMENT-METHOD',
  OPD_BILL_PAYMENT_STATUS: 'OPD-BILL-PAYMENT-STATUS',
  OPD_BILL_STATUS: 'OPD-BILL-STATUS',
  MEDICINE_TYPE: 'MEDICINE-TYPE',
  UPLOAD_FILE_SERVICE_CONTEXT: 'UPLOAD-FILE-SERVICE-CONTEXT',
  UPLOAD_FILE_SERVICE_SUBCONTEXT: 'UPLOAD-FILE-SERVICE-SUBCONTEXT',
} as const;

